// import './modules/modernizr-custom';
import Accordions from './modules/accordion';
import Modals from './modules/modal';
// import Tabs from './modules/tabs';
// import Includes from './modules/include';
// import AnchorLink from './modules/anchorlink';
// import HashUrl from './modules/hash_url';
import AgreeCheck from './modules/check';
import './modules/carousel';
import Zaiko from './modules/zaiko';
import ZaikoCart from './modules/zaiko_cart';
// import ColorCart from './modules/colorcart';
// import Review from './modules/review';
// import './modules/timer';
import '../scss/index.scss';


// // YouCamメイクシミュレーター
// import YouCam from './modules/youcam';
// // API読み込み
// (function (d,k) {
//   var s = d.createElement('script');
//   s.type = 'text/javascript';
//   s.async = true;
//   s.src = 'https://plugins-media.makeupar.com/c317/sdk.js?apiKey=' + k;
//   var x = d.getElementsByTagName('script')[0];
//   x.parentNode.insertBefore(s, x);
// })(document, 'y6xyy2zXnvV8pqT4m49JQ==')

// // ツール初期化
// window.ymkAsyncInit = function() {
//   YMK.init({'autoOpen': true,'language': 'jpn'});
//   window.YMK.addEventListener('loaded', function() {
//     // console.log('loaded!')
//     const vmModal = document.getElementById('modal-vm');
//     if(vmModal){
//       const envBox = vmModal.querySelector('.mod-vmmodal--vmcont_env');
//       const vmBtnBox = vmModal.querySelector('.mod-vmmodal--vmcont_function');
//       envBox.style.display = 'none';
//       vmBtnBox.style.display = 'block';
//     }
//   });
// }

document.addEventListener('DOMContentLoaded',function(){

  // //html include
  // const includeContainers = Array.from(document.querySelectorAll('[data-inc]'));
  // includeContainers.forEach((container) => {
  //   new Includes(container);
  // });

  //在庫制御
  const carts = document.querySelectorAll('.js-module-zaiko');
  const zaikoFlag = 'zaiko-completed';
  const zaikocb = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (!entry.target.classList.contains(zaikoFlag)) {
          new ZaikoCart(entry.target);
          entry.target.classList.add(zaikoFlag);
        }
        observer.unobserve(entry.target);
      }
    });
  };
  const zaikoIOoptions = {
    root: null,
    rootMargin: "100px",
    threshold: 0
  };
  const zaikoio = new IntersectionObserver(zaikocb, zaikoIOoptions);
  if (carts) {
    carts.forEach((cart, index) => {
      cart.setAttribute('data-zaiko_serial', index + 1);
      zaikoio.observe(cart);
    });
  }

  // // レビューAPI
  // const reviewCont = Array.from(document.querySelectorAll('.js-review'));
  // reviewCont.forEach((cont) => {
  //   new Review(cont);
  // });

  //Accordion
  const accordionArray = Array.from(document.querySelectorAll('.js-module-acc'));
  accordionArray.forEach((accordion, index) => {
    accordion.setAttribute('data-accordion_serial', 'accordion_' + (index + 1));
    new Accordions(accordion);
  });
  

  // //Modal window
  // const modalBtns = Array.from(document.querySelectorAll('.js-modal-open'));
  // modalBtns.forEach((modalBtn) => {
  //   new Modals(modalBtn);
  // });

  // //YouCamメイクシミュレーター
  // const vmModalBtns = Array.from(document.querySelectorAll('.js-vmmodal-open'));
  // vmModalBtns.forEach((modalBtn) => {
  //   new YouCam(modalBtn);
  // });

  // //タブ切り替え
  // const tabsBtn = Array.from(document.querySelectorAll('.js-tabs-btn'));
  // tabsBtn.forEach((tabBtn) => {
  //   new Tabs(tabBtn);
  // });

  // // 同意チェック
  const checkboxs = Array.from(document.querySelectorAll('.js-agreecheck-input'));
  checkboxs.forEach((check) => {
    new AgreeCheck(check);
  });

  window.addEventListener('load',function(){

    //Modal window
    const modalArray = Array.from(document.querySelectorAll('.mod-modal'));
    modalArray.forEach( (modal) => {
      new Modals(modal);
    });
    const modalOpenButtonArray = Array.from(document.querySelectorAll('.js-modal-open'));
    modalOpenButtonArray.forEach((button,index) => {
      button.setAttribute('onclick', "_sc.gene_click('modal_" + (index + 1) + "','');");
    });

    // // 色玉在庫制御
    // const colorCarts = Array.from(document.querySelectorAll('.js-colorcart-irodama'));
    // colorCarts.forEach((irodamabtn) => {
    //   new ColorCart(irodamabtn);
    // });

    //smooth anchor
    // 上部固定要素があれば指定する
    // const fixedContent = document.querySelector('.mod-fixednav.m-upper');
    //ページ内リンク
    // let anchorLinks = Array.from(document.querySelectorAll('a'));
    // anchorLinks.forEach((link) => {
    //   // new AnchorLink(link,fixedContent);
    //   // fixedContentなしVersion
    //   new AnchorLink(link);
    // });
    //ハッシュ付きURLでアクセス
    // new HashUrl(fixedContent);
    // fixedContentなしVersion
    // new HashUrl();

    function onClick(){
      var clickObj = $(".scClick");
      clickObj.each (function(){
        var clickID = $(this).attr("data-clickID");
        var clickLink = $(this).attr("href");
        $(this).attr("onclick","_sc.gene_click('" + clickID + "','" + clickLink +"');");
      })
    }
    onClick();

  });

  var myPrice = 0;
    var priceTaxin = '';

    var janParameter = '';
    var cartbtnCode = '';
    var price = 0;
    var cartUrl = '';


    var fdcolorName = '';
    var count = 0;

     $('.js-prod_select').on('click',function(evt){
        evt.preventDefault();
        var unit;
        var thisJan = '';
        var thisPrice = '';
        var thisZaiko = '';
        var thistype = '';
        var idCode = '';

        unit = $(this).parent('.js-zaiko');
        thisJan = '&sweb_shohin_cd=' + unit.attr('data-shohincd');
        idCode = unit.attr('data-shohincd') + '_';
        thisPrice = unit.attr('data-price');
        thisZaiko = unit.attr('data-zaiko');
        thistype = unit.attr('data-type');

        // console.log("thistype:",$('.item_display').find(thistype).length);

        if($(this).hasClass('on')){// すでにチェックが付いていたら削除
            $(this).removeClass('on');
            price = parseInt(price)- parseInt(thisPrice);
            janParameter = String(janParameter.replace(thisJan, ''));
            cartbtnCode = String(cartbtnCode.replace(idCode, ''));
            $('.item_display').find('.'+thistype+'').html(' ');
            $('.item_display').find('.'+thistype+'').siblings().css('display','block');
            $('.item_display').find('.'+thistype+'').removeClass(thistype);
            $(this).parents('.product_cv_prod').find('a:not(.on)').parents('li').removeClass('prod_unselect');
            count--;
        }else{//　チェックが付いていなかったら追加
            $(this).addClass('on');
            fdcolorName ='<div class="item_detail"><p class="item_detail_img">'+ $(this).find('.item_detail_img').html() +'</p><div class="item_detail_info"><p class="item_detail_name">'+ $(this).find('.item_detail_name').html() +'</p><p class="item_detail_dtl">'+ $(this).find('.item_detail_dtl').html() +'</p><p class="item_detail_price">'+ $(this).find('.item_detail_price').html() +'</p></div></div>';

            if($('.step_selected2').has("div").length) {
                $('.step_selected3').siblings().css('display','none');
                $('.step_selected3').addClass(thistype);
                $('.step_selected3').html(fdcolorName);
            } else {
                $('.step_selected2').siblings().css('display','none');
                $('.step_selected2').addClass(thistype);
                $('.step_selected2').html(fdcolorName);
            }

            price = parseInt(price) + parseInt(thisPrice);
            janParameter += String(thisJan);
            cartbtnCode += String(idCode);
            count++;

            if(count == 2) {
                $(this).parents('.product_cv_prod').find('a:not(.on)').parents('li').addClass('prod_unselect');
            }
        }
        //console.log("count:",count);

        myPrice = 0;
        var checkList = $(".on").parents('li');
        for(var i=0;i<checkList.length;i++){
            var checkModel = checkList.eq(i).attr("data-price");
            myPrice = myPrice + parseInt(checkModel)
        }

        priceTaxin = parseInt(myPrice);
        priceTaxin = String(Math.round(priceTaxin)).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
        $('.total_money').text(priceTaxin);

        if(count<2){
            $('.cont').children('.item_display').find('.add_btn').removeClass('on');
            $('.cont').children('.item_display').find('.add_btn a').attr('href', '#');
            $('.cont').children('.item_display').find('.add_btn a').removeAttr('onclick');
        }else{
            var janCode = 'cartbtn_' + cartbtnCode.split('_')[0] + '_' + cartbtnCode.split('_')[1];
            var cartUrl = '/sw/products/SWFG070220.seam?actionMethod=/products%2FSWFG070220.xhtml%3AsWFG070220Action.addCartShohin' + janParameter + '&online_shohin_ctlg_kbn=1&keyword_flg=1'
            var cartClick = "_sc.gene_click('" + janCode + "','" + cartUrl + "')";
            $('.cont').children('.item_display').find('.add_btn').addClass('on');
            $('.cont').children('.item_display').find('.add_btn a').attr('href', cartUrl);
            $('.cont').children('.item_display').find('.add_btn a').attr('onclick', cartClick);
        }
    });


});



